<template>
  <div class="unleash-container margin-general">
    <div class="unleash-tex">
      <div class="unleash-text-container">
        <h2 v-html="formatContent('unleash.title', $t, localPath)"></h2>
        <p class="unleash-text body-4">
          {{ $t("unleash.description") }}
        </p>
        <div class="unleash-buttons">
          <p
            class="unleash-option"
            :class="activeOption === 'Forex' ? 'active' : ''"
            @click="setActiveOption('Forex')"
          >
            {{ $t("unleash.forex") }}
          </p>
          <p
            class="unleash-option"
            :class="activeOption === 'Stocks' ? 'active' : ''"
            @click="setActiveOption('Stocks')"
          >
            {{ $t("unleash.stocks") }}
          </p>
          <!-- <p
            class="unleash-option"
            :class="activeOption === 'Futures' ? 'active' : ''"
            @click="setActiveOption('Futures')"
          >
            {{ $t("unleash.futures") }}
          </p> -->
        </div>
      </div>
    </div>
    <div class="unleash-image">
      <div class="unleash-image-forex" v-if="activeOption === 'Forex'">
        <NuxtImg
          src="/images/home/HomeForex-TradingPlatformsBG.png"
          alt="Background"
          width="420"
          height="600"
          sizes="sm:100vw md:50vw lg:33vw"
          format="webp"
          quality="85"
          loading="lazy"
          decoding="async"
         
        />
        <span class="visually-hidden"
          >Two smartphones displaying stock charts</span
        >
        <div class="unleash-image-content">
          <p class="unleash-image-title body-3" style="color: transparent">.</p>
          <p class="unleash-image-title body-3" style="color: transparent">.</p>
          <p class="unleash-image-title body-3" style="color: transparent">.</p>
          <p class="unleash-image-title body-3">{{ $t("unleash.forex") }}</p>
          <!-- <p class="unleash-image-text body-4">{{ $t("unleash.meta4") }}</p> -->
          <p class="unleash-image-text body-4">{{ $t("unleash.meta5") }}</p>
          <!-- <p class="unleash-image-text-end body-4">
            {{ $t("unleash.cTrader") }}
          </p> -->
          <NuxtLink :to="localPath('/trading/platforms')">
            <button>{{ $t("unleash.explorePlatforms") }}</button>
          </NuxtLink>
        </div>
      </div>
      <div class="unleash-image-stocks" v-if="activeOption === 'Stocks'">
        <NuxtImg
          src="/images/home/HomeStocks-TradingPlatformsBG.png"
          alt="Background"
          width="420"
          height="600"
          sizes="sm:100vw md:50vw lg:33vw"
          format="webp"
          quality="85"
         
        />
        <span class="visually-hidden"
          >Stock price changes on computer screen</span
        >
        <div class="unleash-image-content">
          <p class="unleash-image-title body-3">
            {{ $t("unleash.stocks-option") }}
          </p>
          <p class="unleash-image-text body-4">{{ $t("unleash.meta5") }}</p>
          <!-- <p class="unleash-image-text body-4">{{ $t("unleash.sterling") }}</p>
          <p class="unleash-image-text body-4">
            {{ $t("unleash.lightspeed") }}
          </p>
          <p class="unleash-image-text body-4">{{ $t("unleash.takion") }}</p>
          <p class="unleash-image-text body-4">{{ $t("unleash.das") }}</p>
          <p class="unleash-image-text-end body-4">
            {{ $t("unleash.api-fix") }}
          </p> -->
          <NuxtLink :to="localPath('/trading/platforms')">
            <button>{{ $t("unleash.explorePlatforms") }}</button>
          </NuxtLink>
        </div>
      </div>
      <!-- <div class="unleash-image-features" v-if="activeOption === 'Futures'">
        <NuxtImg
          src="/images/home/HomeOptions-TradingPlatformsBG.png"
          alt="Background"
          width="420"
          height="600"
          sizes="sm:100vw md:50vw lg:33vw"
          format="webp"
          quality="85"
         
        />
        <span class="visually-hidden">Financial markets on computer</span>
        <div class="unleash-image-content">
          <p class="unleash-image-title body-3" style="color: transparent">.</p>
          <p class="unleash-image-title body-3" style="color: transparent">.</p>
          <p class="unleash-image-title body-3" style="color: transparent">.</p>
          <p class="unleash-image-title body-3">{{ $t("unleash.futures") }}</p>
          <p class="unleash-image-text body-4">{{ $t("unleash.meta5") }}</p>
          <p class="unleash-image-text body-4">{{ $t("unleash.CQG") }}</p>
          <p class="unleash-image-text-end body-4">
            {{ $t("unleash.api-fix") }}
          </p>
          <NuxtLink :to="localPath('/trading/platforms')">
            <button>{{ $t("unleash.explorePlatforms") }}</button>
          </NuxtLink>
        </div>
      </div> -->
    </div>
  </div>
</template>
<script setup>
import { ref } from "vue";
import { formatContent } from '~/utils/formatContent';

const localPath = useLocalePath();
const activeOption = ref("Forex");
const setActiveOption = (option) => {
  activeOption.value = option;
};
</script>